import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

import { PaymentApplicationStatus } from '../models/plans.model';

export interface SmsPackage {
    _id: string;
    title: string;
    description?: string;
    amountmsm: number;
    amount: number;
    createdAt?: string;
    updatedAt?: string;
}

export interface SmsPackagesResponse {
    title: string;
    message: string;
    data: SmsPackage[];
}

export interface BuySmsRequest {
    sms: number;
    amount: number;
    paymentMethod: string;
    ref: string;
    currencyType: 'VES' | 'USD';
    exchangeRateBCV?: number;
}

export type SmsPaymentStatus = 'procesando' | 'pago' | 'verificando-por-fina';

export interface SmsPaymentVerificationView {
    label?: string;
    summary?: string;
    outcome?: string;
    autoApprove?: boolean;
    requiresManualReview?: boolean;
    applicationStatus?: PaymentApplicationStatus | null;
}

export interface BuySmsResponse {
    title: string;
    message: string;
    data: {
        billPlanId: string;
        effectiveBillStatus: SmsPaymentStatus;
        paymentVerification?: SmsPaymentVerificationView;
    };
}

@Injectable({
    providedIn: 'root',
})
export class SmsService {
    private readonly API_URL = environment.API_URL;
    private packages$?: Observable<SmsPackage[]>;

    constructor(private http: HttpClient) {}

    getSmsPackages$(): Observable<SmsPackage[]> {
        if (!this.packages$) {
            this.packages$ = this.http.get<SmsPackagesResponse>(`${this.API_URL}/sms`).pipe(
                map(res => res?.data ?? []),
                catchError(err => {
                    this.packages$ = undefined;
                    return throwError(() => err);
                }),
                shareReplay({ bufferSize: 1, refCount: false }),
            );
        }
        return this.packages$;
    }

    buySms$(data: BuySmsRequest): Observable<BuySmsResponse> {
        return this.http.post<BuySmsResponse>(`${this.API_URL}/sms/buy`, data);
    }

    /**
     * Compra SMS con tarjeta guardada (Stripe on-session).
     * `amount` es el total USD con IVA; el proxy valida el catálogo y cobra.
     */
    buySmsWithCard$(sms: number, amount: number): Observable<any> {
        return this.http.post<any>(`${this.API_URL}/sms/buy-with-card`, { sms, amount });
    }
}
